const OpsChapterPath = require("./OpsChapterPath");
const OpsMarketing = require("./OpsMarketing");
const OpsTempUser = require("./OpsTempUser");
const OpsTutorial = require("./OpsTutorial");
const OpsUser = require("./OpsUser");
const TimeTracking = require("./TimeTracking");

const resetVaultState = function(vault, preResetState) {
	const now = vault.clock.now();
	let resetState = {
		beastbuilder: {},
		cart: null, // set in a hook defined in the office bundle
		chapterPath: OpsChapterPath.init(),
		cmsInfoPage: preResetState.cmsInfoPage,
		connected:
			preResetState.connected !== undefined ? preResetState.connected : true,
		contentReport: {},
		demo: {},
		devProblem: null,
		idle: preResetState.idle !== undefined ? preResetState.idle : false,
		leaderboards: {},
		library: {},
		lockOverrides: {},
		marketing: OpsMarketing.init(preResetState.marketing),
		office: null, // set in a hook defined in the office bundle
		page: preResetState.page || {},
		parentAccount: null, // set in a hook defined in the office bundle
		profile: {},
		profileActivity: {},
		profileActivityDay: {},
		profileChapters: {},
		readAloud: {},
		school: {},
		sharedProblemModels: {},
		tempUser: OpsTempUser.init(),
		timeTracking: TimeTracking.init(preResetState.timeTracking),
		tutorial: OpsTutorial.init(),
		user: OpsUser.init(),
		userData: {},
	};
	const hooks = vault.hooks.reset || [];
	resetState = hooks.reduce(
		(currState, f) => f(currState, preResetState, now),
		resetState
	);
	return resetState;
};

// f is a function taking (state, preResetState, now) and returning a modified state value.
const addResetHook = function(vault, f) {
	vault.hooks.reset = vault.hooks.reset || [];
	vault.hooks.reset.push(f);
};

module.exports = {
	resetVaultState,
	addResetHook,
};
